import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog } from "@intelligems/ig-theme";
import { GenericExperienceFe } from "@intelligems/ig-types";

import { useConfiguration } from "../../../../api/configurations/use-configuration";
import { useStartExperience } from "../../../../api/experience-actions/start-experience";
import { useIsAdmin } from "../../../../api/user-auths/is-admin";
import { isDialogOpen, setDialog } from "../../../../store/slices/global";

const PREFIX = "PriceUpdaterDialog";

interface StartPriceTestDialogProps {
  experience: GenericExperienceFe;
}

export const StartPriceTestDialog = ({
  experience,
}: StartPriceTestDialogProps) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("priceUpdaterStart"));
  const isAdmin = useIsAdmin();
  const downloadPriceCSVEnabled = useConfiguration("enable_price_csv_download");
  const startExperience = useStartExperience();

  const handleExperienceTestStart = (updatePrices: boolean) => {
    startExperience.mutate({
      body: {
        variationId: updatePrices ? null : undefined,
        updatePricesToVariation: updatePrices,
      },
      pathParams: {
        name: experience.name,
        pausedAtTs: experience.pausedAtTs ?? 0,
        experienceId: experience.id!,
        action: "start",
      },
      queryParams: undefined,
    });
    dispatch(
      setDialog({
        dialog: "priceUpdaterStart",
        open: false,
        props: { action: "none" },
      })
    );
  };

  const adminManualPriceOverride: boolean = !!(
    isAdmin || downloadPriceCSVEnabled?.value
  );

  const closePriceUpdaterStartDialog = () => {
    dispatch(
      setDialog({
        dialog: "priceUpdaterStart",
        open: false,
        props: { action: "none" },
      })
    );
  };

  return (
    <IgDialog
      showDialog={isOpen}
      fullWidth={true}
      handleClose={closePriceUpdaterStartDialog}
      title={
        "Do you want the Intelligems Wizard to update your Shopify prices?"
      }
      yesButtonText={"Yes, Update My Prices and Start Test"}
      handleYesClick={() => handleExperienceTestStart(true)}
      noButtonText={
        adminManualPriceOverride ? "No, I'll Update My Prices" : "Cancel"
      }
      handleNoClick={() => {
        if (isAdmin || downloadPriceCSVEnabled?.value) {
          handleExperienceTestStart(false);
        } else {
          closePriceUpdaterStartDialog();
        }
      }}
      maxWidth={"sm"}
      loading={startExperience.isPending}
    />
  );
};
